
import React, { useState } from 'react';
import { makeStyles, useTheme } from '@mui/styles';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import LinearProgress from "@mui/material/LinearProgress";


import { showErrorSnackbar } from 'store/actions/snackbarMessage';
import { useDispatch } from 'react-redux';
import { getTodayDishReport } from "apis/reportAPIs";
import { useQuery } from "@tanstack/react-query";



const useStyles = makeStyles((theme) => ({
    root: {

    },
    table: {


    },
    top: {
        marginTop: theme.spacing(1)
    }
}));



const DishReport = (props) => {
    const { user, currencySymbol } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
  
    
    const [reportData, setReportData] = useState([]);
    const theme = useTheme();
    const showError = (msg) => dispatch(showErrorSnackbar(msg));


    
    const { data, isLoading, error } = useQuery({
        queryKey: ['todayDishReport'],
        queryFn: () => getTodayDishReport(),
        enabled: !!user && user.role !== 'restaurantManager',
        gcTime: 1 * 60 * 1000, // 1 minutes (renamed from cacheTime in v5)
      });
    
    // Safety check: if user is not loaded yet, don't render the report
    if (!user) {
        return null;
    }

    return (
        <div className={classes.root}>
        {isLoading ? <LinearProgress style = {{ marginBottom: 8,  marginTop: 8 }}/> : null}
          <Typography variant="h5" gutterBottom>
               Today Dish Report
            </Typography>
       
            <TableContainer component={Paper} className={classes.top}>
                <Table className={classes.table} aria-label="dish table">
               
                  
                    <TableHead>
                        <TableRow>
                            <TableCell>No</TableCell>
                            <TableCell align="left">Name</TableCell>
                            <TableCell align="right">Quantity</TableCell>
                            <TableCell align="right">Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data  && data.length > 0 && data.map((item, index) => {
                            return (
                                <TableRow key={item.name}>
                                    <TableCell component="th" scope="row" >

                                        {index + 1}

                                    </TableCell>
                                  
                                    <TableCell align="left">
                                    <Typography>
                                        {item.name}
                                        </Typography>
                                        <Typography>
                                        {item.altName}
                                        </Typography>
                                        </TableCell>
                                    <TableCell align="right">{item.count}</TableCell>
                                    <TableCell align="right">{currencySymbol}{!isNaN(item.total) ? Number(item.total).toFixed(2): item.total}</TableCell>

                                </TableRow>
                            )
                        })}


                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    );
}

export default DishReport;
